import { render, staticRenderFns } from "./CaixaAberto.vue?vue&type=template&id=23a3177a&scoped=true"
import script from "./CaixaAberto.vue?vue&type=script&lang=js"
export * from "./CaixaAberto.vue?vue&type=script&lang=js"
import style0 from "./CaixaAberto.vue?vue&type=style&index=0&id=23a3177a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a3177a",
  null
  
)

export default component.exports